/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-ComboBoxBasicExample{max-width:300px}"}]);
/* tslint:enable */